export const TableGroupActions = {
  Hide: "hide_group",
  Show: "show_group",
  ShowAll: "show_all_hidden_groups",
  Select: "select_group_chart"
};
